"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License. See License.txt in the project root for license information.
var _classCallCheck = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/inherits");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var msRest = require("ms-rest-js");
var constants_1 = require("./util/constants");
var pollingState_1 = require("./pollingState");
var LroStates = constants_1.default.LongRunningOperationStates;
/**
 * @class
 * Initializes a new instance of the AzureServiceClient class.
 * @constructor
 *
 * @param {msRest.ServiceClientCredentilas} credentials - ApplicationTokenCredentials or
 * UserTokenCredentials object used for authentication.
 * @param {AzureServiceClientOptions} options - The parameter options used by AzureServiceClient
 */
var AzureServiceClient = /*#__PURE__*/function (_msRest$ServiceClient) {
  function AzureServiceClient(credentials, options) {
    var _this;
    _classCallCheck(this, AzureServiceClient);
    _this = _callSuper(this, AzureServiceClient, [credentials, options]);
    _this.acceptLanguage = constants_1.default.DEFAULT_LANGUAGE;
    _this.generateClientRequestId = true;
    _this.longRunningOperationRetryTimeout = 30;
    _this.rpRegistrationRetryTimeout = 30;
    _this.acceptLanguage = constants_1.default.DEFAULT_LANGUAGE;
    _this.generateClientRequestId = true;
    _this.longRunningOperationRetryTimeout = 30;
    if (!options) options = {};
    if (options.acceptLanguage !== null && options.acceptLanguage !== undefined) {
      _this.acceptLanguage = options.acceptLanguage;
    }
    if (options.generateClientRequestId !== null && options.generateClientRequestId !== undefined) {
      _this.generateClientRequestId = options.generateClientRequestId;
    }
    if (options.longRunningOperationRetryTimeout !== null && options.longRunningOperationRetryTimeout !== undefined) {
      _this.longRunningOperationRetryTimeout = options.longRunningOperationRetryTimeout;
    }
    if (options.rpRegistrationRetryTimeout !== null && options.rpRegistrationRetryTimeout !== undefined) {
      _this.rpRegistrationRetryTimeout = options.rpRegistrationRetryTimeout;
    }
    try {
      var moduleName = "ms-rest-azure";
      var moduleVersion = constants_1.default.msRestAzureVersion;
      _this.addUserAgentInfo("".concat(moduleName, "/").concat(moduleVersion));
    } catch (err) {
      // do nothing
    }
    return _this;
  }
  /**
   * Provides a mechanism to make a request that will poll and provide the final result.
   * @param {msRest.RequestPrepareOptions|msRest.WebResource} request - The request object
   * @param {msRest.RequestOptionsBase} [options] Additional options to be sent while making the request
   * @returns {Promise<msRest.HttpOperationResponse>} The HttpOperationResponse containing the final polling request, response and the responseBody.
   */
  _inherits(AzureServiceClient, _msRest$ServiceClient);
  return _createClass(AzureServiceClient, [{
    key: "sendLongRunningRequest",
    value: function sendLongRunningRequest(request, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var self, initialResponse, finalResponse;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              self = this;
              _context.prev = 1;
              _context.next = 4;
              return self.sendRequest(request);
            case 4:
              initialResponse = _context.sent;
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              return _context.abrupt("return", Promise.reject(_context.t0));
            case 10:
              _context.prev = 10;
              _context.next = 13;
              return self.getLongRunningOperationResult(initialResponse, options);
            case 13:
              finalResponse = _context.sent;
              _context.next = 19;
              break;
            case 16:
              _context.prev = 16;
              _context.t1 = _context["catch"](10);
              return _context.abrupt("return", Promise.reject(_context.t1));
            case 19:
              return _context.abrupt("return", Promise.resolve(finalResponse));
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 7], [10, 16]]);
      }));
    }
    /**
     * Verified whether an unexpected polling status code for long running operation was received for the response of the initial request.
     * @param {msRest.HttpOperationResponse} initialResponse - Response to the initial request that was sent as a part of the asynchronous operation.
     */
  }, {
    key: "checkResponseStatusCodeFailed",
    value: function checkResponseStatusCodeFailed(initialResponse) {
      var statusCode = initialResponse.response.status;
      var method = initialResponse.request.method;
      if (statusCode === 200 || statusCode === 202 || statusCode === 201 && method === "PUT" || statusCode === 204 && (method === "DELETE" || method === "POST")) {
        return false;
      } else {
        return true;
      }
    }
    /**
     * Poll Azure long running PUT, PATCH, POST or DELETE operations.
     * @param {msRest.HttpOperationResponse} resultOfInitialRequest - result/response of the initial request which is a part of the asynchronous polling operation.
     * @param {msRest.RequestOptionsBase} [options] - custom request options.
     * @returns {Promise<msRest.HttpOperationResponse>} result - The final response after polling is complete.
     */
  }, {
    key: "getLongRunningOperationResult",
    value: function getLongRunningOperationResult(resultOfInitialRequest, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var self, initialRequestMethod, pollingState, resourceUrl;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              self = this;
              initialRequestMethod = resultOfInitialRequest.request.method;
              if (!self.checkResponseStatusCodeFailed(resultOfInitialRequest)) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return", Promise.reject("Unexpected polling status code from long running operation " + "\"".concat(resultOfInitialRequest.response.status, "\" for method \"").concat(initialRequestMethod, "\".")));
            case 4:
              _context2.prev = 4;
              pollingState = new pollingState_1.default(resultOfInitialRequest, self.longRunningOperationRetryTimeout);
              pollingState.optionsOfInitialRequest = options;
              _context2.next = 12;
              break;
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](4);
              return _context2.abrupt("return", Promise.reject(_context2.t0));
            case 12:
              resourceUrl = resultOfInitialRequest.request.url;
            case 13:
              if ([LroStates.Succeeded, LroStates.Failed, LroStates.Canceled].some(function (e) {
                return e === pollingState.status;
              })) {
                _context2.next = 34;
                break;
              }
              _context2.next = 16;
              return msRest.delay(pollingState.getTimeout());
            case 16:
              if (!pollingState.azureAsyncOperationHeaderLink) {
                _context2.next = 21;
                break;
              }
              _context2.next = 19;
              return self.updateStateFromAzureAsyncOperationHeader(pollingState, true);
            case 19:
              _context2.next = 32;
              break;
            case 21:
              if (!pollingState.locationHeaderLink) {
                _context2.next = 26;
                break;
              }
              _context2.next = 24;
              return self.updateStateFromLocationHeader(initialRequestMethod, pollingState);
            case 24:
              _context2.next = 32;
              break;
            case 26:
              if (!(initialRequestMethod === "PUT")) {
                _context2.next = 31;
                break;
              }
              _context2.next = 29;
              return self.updateStateFromGetResourceOperation(resourceUrl, pollingState);
            case 29:
              _context2.next = 32;
              break;
            case 31:
              return _context2.abrupt("return", Promise.reject(new Error("Location header is missing from long running operation.")));
            case 32:
              _context2.next = 13;
              break;
            case 34:
              if (!(pollingState.status === LroStates.Succeeded)) {
                _context2.next = 44;
                break;
              }
              if (!((pollingState.azureAsyncOperationHeaderLink || !pollingState.resource) && (initialRequestMethod === "PUT" || initialRequestMethod === "PATCH"))) {
                _context2.next = 41;
                break;
              }
              _context2.next = 38;
              return self.updateStateFromGetResourceOperation(resourceUrl, pollingState);
            case 38:
              return _context2.abrupt("return", Promise.resolve(pollingState.getOperationResponse()));
            case 41:
              return _context2.abrupt("return", Promise.resolve(pollingState.getOperationResponse()));
            case 42:
              _context2.next = 45;
              break;
            case 44:
              return _context2.abrupt("return", Promise.reject(pollingState.getRestError()));
            case 45:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 9]]);
      }));
    }
    /**
     * Retrieve operation status by polling from "azure-asyncoperation" header.
     * @param {PollingState} pollingState - The object to persist current operation state.
     * @param {boolean} inPostOrDelete - Invoked by Post Or Delete operation.
     */
  }, {
    key: "updateStateFromAzureAsyncOperationHeader",
    value: function updateStateFromAzureAsyncOperationHeader(pollingState) {
      var inPostOrDelete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var result, parsedResponse;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return this.getStatus(pollingState.azureAsyncOperationHeaderLink, pollingState.optionsOfInitialRequest);
            case 3:
              result = _context3.sent;
              _context3.next = 9;
              break;
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              return _context3.abrupt("return", Promise.reject(_context3.t0));
            case 9:
              parsedResponse = result.bodyAsJson;
              if (parsedResponse) {
                _context3.next = 14;
                break;
              }
              return _context3.abrupt("return", Promise.reject(new Error("The response from long running operation does not contain a body.")));
            case 14:
              if (!(parsedResponse && !parsedResponse.status)) {
                _context3.next = 16;
                break;
              }
              return _context3.abrupt("return", Promise.reject(new Error("The response \"".concat(result.bodyAsText, "\" from long running operation does not contain the status property."))));
            case 16:
              pollingState.status = parsedResponse.status;
              pollingState.error = parsedResponse.error;
              pollingState.updateResponse(result.response);
              pollingState.request = result.request;
              pollingState.resource = undefined;
              if (inPostOrDelete) {
                pollingState.resource = result.bodyAsJson;
              }
              return _context3.abrupt("return", Promise.resolve());
            case 23:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 6]]);
      }));
    }
    /**
     * Retrieve PUT operation status by polling from "location" header.
     * @param {string} method - The HTTP method.
     * @param {PollingState} pollingState - The object to persist current operation state.
     */
  }, {
    key: "updateStateFromLocationHeader",
    value: function updateStateFromLocationHeader(method, pollingState) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var result, parsedResponse, statusCode;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return this.getStatus(pollingState.locationHeaderLink, pollingState.optionsOfInitialRequest);
            case 3:
              result = _context4.sent;
              _context4.next = 9;
              break;
            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              return _context4.abrupt("return", Promise.reject(_context4.t0));
            case 9:
              parsedResponse = result.bodyAsJson;
              pollingState.updateResponse(result.response);
              pollingState.request = result.request;
              statusCode = result.response.status;
              if (!(statusCode === 202)) {
                _context4.next = 17;
                break;
              }
              pollingState.status = LroStates.InProgress;
              _context4.next = 25;
              break;
            case 17:
              if (!(statusCode === 200 || statusCode === 201 && (method === "PUT" || method === "PATCH") || statusCode === 204 && (method === "DELETE" || method === "POST"))) {
                _context4.next = 24;
                break;
              }
              pollingState.status = LroStates.Succeeded;
              pollingState.resource = parsedResponse;
              // we might not throw an error, but initialize here just in case.
              pollingState.error = new msRest.RestError("Long running operation failed with status \"".concat(pollingState.status, "\"."));
              pollingState.error.code = pollingState.status;
              _context4.next = 25;
              break;
            case 24:
              return _context4.abrupt("return", Promise.reject(new Error("The response with status code ".concat(statusCode, " from polling for ") + "long running operation url \"".concat(pollingState.locationHeaderLink, "\" is not valid."))));
            case 25:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 6]]);
      }));
    }
    /**
     * Polling for resource status.
     * @param {string} resourceUrl - The url of resource.
     * @param {PollingState} pollingState - The object to persist current operation state.
     */
  }, {
    key: "updateStateFromGetResourceOperation",
    value: function updateStateFromGetResourceOperation(resourceUrl, pollingState) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var result, parsedResponse;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return this.getStatus(resourceUrl, pollingState.optionsOfInitialRequest);
            case 3:
              result = _context5.sent;
              _context5.next = 9;
              break;
            case 6:
              _context5.prev = 6;
              _context5.t0 = _context5["catch"](0);
              return _context5.abrupt("return", Promise.reject(_context5.t0));
            case 9:
              if (result.bodyAsJson) {
                _context5.next = 11;
                break;
              }
              return _context5.abrupt("return", Promise.reject(new Error("The response from long running operation does not contain a body.")));
            case 11:
              parsedResponse = result.bodyAsJson;
              pollingState.status = LroStates.Succeeded;
              if (parsedResponse && parsedResponse.properties && parsedResponse.properties.provisioningState) {
                pollingState.status = parsedResponse.properties.provisioningState;
              }
              pollingState.updateResponse(result.response);
              pollingState.request = result.request;
              pollingState.resource = parsedResponse;
              // we might not throw an error, but initialize here just in case.
              pollingState.error = new msRest.RestError("Long running operation failed with status \"".concat(pollingState.status, "\"."));
              pollingState.error.code = pollingState.status;
              return _context5.abrupt("return", Promise.resolve());
            case 20:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 6]]);
      }));
    }
    /**
     * Retrieves operation status by querying the operation URL.
     * @param {string} operationUrl - URL used to poll operation result.
     * @param {object} options - Options that can be set on the request object
     */
  }, {
    key: "getStatus",
    value: function getStatus(operationUrl, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var self, requestUrl, httpRequest, customHeaders, headerName, operationResponse, statusCode, responseBody, error;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              self = this; // Construct URL
              requestUrl = operationUrl.replace(" ", "%20"); // Create HTTP request object
              httpRequest = {
                method: "GET",
                url: requestUrl,
                headers: {}
              };
              if (options) {
                customHeaders = options.customHeaders;
                for (headerName in customHeaders) {
                  if (customHeaders.hasOwnProperty(headerName)) {
                    httpRequest.headers[headerName] = customHeaders[headerName];
                  }
                }
              }
              _context6.prev = 4;
              _context6.next = 7;
              return self.sendRequest(httpRequest);
            case 7:
              operationResponse = _context6.sent;
              _context6.next = 13;
              break;
            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](4);
              return _context6.abrupt("return", Promise.reject(_context6.t0));
            case 13:
              statusCode = operationResponse.response.status;
              responseBody = operationResponse.bodyAsJson;
              if (!(statusCode !== 200 && statusCode !== 201 && statusCode !== 202 && statusCode !== 204)) {
                _context6.next = 22;
                break;
              }
              error = new msRest.RestError("Invalid status code with response body \"".concat(operationResponse.bodyAsText, "\" occurred ") + "when polling for operation status.");
              error.statusCode = statusCode;
              error.request = msRest.stripRequest(operationResponse.request);
              error.response = operationResponse.response;
              try {
                error.body = responseBody;
              } catch (badResponse) {
                error.message += " Error \"".concat(badResponse, "\" occured while deserializing the response body - \"").concat(operationResponse.bodyAsText, "\".");
                error.body = operationResponse.bodyAsText;
              }
              return _context6.abrupt("return", Promise.reject(error));
            case 22:
              return _context6.abrupt("return", Promise.resolve(operationResponse));
            case 23:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[4, 10]]);
      }));
    }
  }]);
}(msRest.ServiceClient);
exports.AzureServiceClient = AzureServiceClient;